"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYNC_BACKGROUNDS = exports.BROADCAST_UPLOAD_BACKGROUND = exports.BROADCAST_TOGGLE_BACKGROUND_STATUS = exports.BROADCAST_TOGGLE_BACKGROUND_HIDDEN = exports.BROADCAST_TAKE_BACKGROUND_LIVE = exports.BROADCAST_CREATE_BACKGROUND = exports.BROADCAST_BACKGROUND_SCAN = void 0;
var SYNC_BACKGROUNDS = exports.SYNC_BACKGROUNDS = 'SYNC_BACKGROUNDS';
var BROADCAST_TOGGLE_BACKGROUND_STATUS = exports.BROADCAST_TOGGLE_BACKGROUND_STATUS = 'BROADCAST_TOGGLE_BACKGROUND_STATUS';
var BROADCAST_TOGGLE_BACKGROUND_HIDDEN = exports.BROADCAST_TOGGLE_BACKGROUND_HIDDEN = 'BROADCAST_TOGGLE_BACKGROUND_HIDDEN';
var BROADCAST_CREATE_BACKGROUND = exports.BROADCAST_CREATE_BACKGROUND = 'BROADCAST_CREATE_BACKGROUND';
var BROADCAST_UPLOAD_BACKGROUND = exports.BROADCAST_UPLOAD_BACKGROUND = 'BROADCAST_UPLOAD_BACKGROUND';
var BROADCAST_BACKGROUND_SCAN = exports.BROADCAST_BACKGROUND_SCAN = 'BROADCAST_BACKGROUND_SCAN';
var BROADCAST_TAKE_BACKGROUND_LIVE = exports.BROADCAST_TAKE_BACKGROUND_LIVE = 'BROADCAST_TAKE_BACKGROUND_LIVE';